import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-login-corp]')) return;

  datalayerLogin();
}

function datalayerLogin() {
  $$('[data-au-datalayer-login-submmit]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-login-corp]').querySelector('[data-au-login-corp-form-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;
      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id,
      });
    });
  });

  const linkRecover = $('[data-au-datalayer-login-link]');

  if (linkRecover) {
    linkRecover.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-login-corp]').querySelector('[data-au-login-corp-form-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  } else {
    return;
  }
}
export default { init };
